import { Fragment, useEffect, useState } from "react";
import "./subject_collection_view.scss";
import images from "../../../../../../utilities/images/images";
import axios from "axios";
import { backGroundColorFromBackend } from "../../../../../../custom_utilities/custom_useful_functions";
import { url_8, url_9 } from "../../../../../../custom_utilities/api_services";
//slick-carousel
import Slider from "react-slick";
//Redux
import { connect } from "react-redux";
import userActivityActions from "../../../../../../redux/user_activity/action";

export const SUBJECT_SCREEN_OLD_PATH = "/subject_component";
export const SUBJECT_SCREEN_NEW_PATH = "/dashboard/student-learning";

const EMPTY_SUBJECT_VIEW = {
  isCategorized: false,
  categories: [],
  subjects: [],
};

const SubjectCollectionView = (props) => {
  let {
    history,
    userPreference,
    setSubjectData,
    setCategoryData,
    setIsCategorizedSub,
  } = props;
  let { courseDetails, classDetails, targetDetails } = userPreference;
  const courseId = courseDetails?.[0]?.course_id;
  const classId = classDetails?.class_id;
  const targetId = targetDetails?.[0]?.target_id;

  const [subjectView, setSubjectView] = useState(EMPTY_SUBJECT_VIEW);

  useEffect(() => {
    if (courseId == null || classId == null) return undefined;

    let isActive = true;
    // Drop the previous target's list immediately so a refresh cannot keep it on screen.
    setSubjectView(EMPTY_SUBJECT_VIEW);
    setCategoryData({ category: [] });
    setIsCategorizedSub({ is_categorized_sub: 0 });

    const getSubjectList = async () => {
      try {
        const profileResponse = await axios.get(url_8);
        if (!isActive || profileResponse.data.status !== 200) return;

        const profile = profileResponse.data.data || {};
        const isCategorized = Number(profile.is_categorized_sub) === 1;
        const categories = Array.isArray(profile.category) ? profile.category : [];

        if (isCategorized) {
          setSubjectView({
            isCategorized: true,
            categories,
            subjects: [],
          });
          setCategoryData({ category: categories });
          setIsCategorizedSub({ is_categorized_sub: 1 });
          return;
        }

        const response = await axios.post(url_9, {
          course_id: courseId,
          class_id: classId,
        });
        if (!isActive || response.data.status !== 200) return;

        const subjects = Array.isArray(response.data.data?.subject)
          ? response.data.data.subject
          : [];

        setSubjectView({
          isCategorized: false,
          categories: [],
          subjects,
        });
        setCategoryData({ category: [] });
        setIsCategorizedSub({ is_categorized_sub: 0 });
      } catch (error) {
        console.log(error);
      }
    };

    getSubjectList();

    return () => {
      isActive = false;
    };
  }, [courseId, classId, targetId, setCategoryData, setIsCategorizedSub]);

  const renderSubjectImage = (icon) => {
    if (icon) {
      return <img src={icon} alt="" />;
    } else {
      return <img src={images.user_dashboard_5} alt="" />;
    }
  };

  const navigateToSubjectScreen = (element, screenVersion = "new") => {
    const pathname =
      screenVersion === "new" ? SUBJECT_SCREEN_NEW_PATH : SUBJECT_SCREEN_OLD_PATH;

    if (subjectView.isCategorized) {
      props.setSelectedCategory(element.id);

      setSubjectData({
        categoryId: element.id,
        subjectId: element.subject?.[0]?.sub_id || "",
        subjectName: element.subject?.[0]?.sub_name || "",
        subjectIcon: element.subject?.[0]?.icon || "",
        subjects: element.subject || [],
        categoryName: element.name,
      });

      history.push({
        pathname,
        state: {
          categoryId: element.id,
          screenVersion,
          returnTo: history?.location?.pathname || "/dashboard",
        },
      });
      return;
    }

    setSubjectData({
      subjectId: element.sub_id,
      subjectName: element.sub_name,
      subjectIcon: element.icon,
    });

    props.setSelectedCategory("");

    history.push({
      pathname,
      state: {
        screenVersion,
        returnTo: history?.location?.pathname || "/dashboard",
      },
    });
  };

  const handleRedirect = (type, element) => {
    switch (type.toLowerCase()) {
      case "all":
        history.push(SUBJECT_SCREEN_OLD_PATH);
        break;
      case "subject":
        navigateToSubjectScreen(element, "new");
        break;
      default:
        break;
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          // dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          autoplay: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Fragment>
      <div className="subjectCollectionView_wrapper">
        <div className="subjectCollectionView_inner_wrapper">
          <div className="container">
            <div className="subject_collection">
              <div className="subject_collection_desktop">
                <Slider {...settings}>
                  {subjectView.isCategorized
                    ? subjectView.categories.map((element, index) => (
                        <div
                          className="home_page_single_subject_box"
                          key={element?.sub_id}
                        >
                          <div
                            className="home_page_single_subject"
                            onClick={() => handleRedirect("subject", element)}
                            style={backGroundColorFromBackend(
                              element.color_code
                            )}
                          >
                            <div className="home_page_image_wrapper">
                              {renderSubjectImage(element?.icon)}
                            </div>
                            <div className="home_page_text_content_wrapper">
                              <p className="home_page_text_content">
                                {element?.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                    : subjectView.subjects.length > 0 &&
                      subjectView.subjects.map((subject, index) => (
                        <div
                          className="home_page_single_subject_box"
                          key={subject?.sub_id}
                        >
                          <div
                            className="home_page_single_subject"
                            onClick={() => handleRedirect("subject", subject)}
                            style={backGroundColorFromBackend(
                              subject.color_code
                            )}
                          >
                            <div className="home_page_image_wrapper">
                              {renderSubjectImage(subject?.icon)}
                            </div>
                            <div className="home_page_text_content_wrapper">
                              <p className="home_page_text_content">
                                {subject?.sub_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSubjectData: (payload) => {
      dispatch(userActivityActions.setSubjectData(payload));
    },
    setSelectedCategory: (payload) => {
      dispatch(userActivityActions.setSelectedCategory(payload));
    },
    setCategoryData: (payload) => {
      dispatch(userActivityActions.setCategoryData(payload));
    },
    setIsCategorizedSub: (payload) => {
      dispatch(userActivityActions.setIsCategorizedSub(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubjectCollectionView);
